import { api } from '@/api/client';

export interface InviteBasicResponse {
  id: string;
  companyName: string;
  email: string;
  expiresAt: string;
  createdAt: string;
}

export interface MyInvitesResponse {
  invites: InviteBasicResponse[];
}

/** Fetches all pending invitations for the currently authenticated user. */
export async function fetchMyInvites(): Promise<MyInvitesResponse> {
  return api.get<MyInvitesResponse>('/v1/me/invites');
}

/** Accepts a pending invitation by its ID. */
export async function acceptInvite(inviteId: string): Promise<void> {
  await api.post(`/v1/invites/${inviteId}/accept`);
}

/** Rejects a pending invitation by its ID. */
export async function declineInvite(inviteId: string): Promise<void> {
  await api.post(`/v1/invites/${inviteId}/reject`);
}
